import React, { useState, useEffect } from 'react';

import './styles.css';

import ActivityIndicator from '../../../../../components/ActivityIndicator'

import { FaUsers } from 'react-icons/fa';
import accessServices from '../../../../../services/accessServices';
import AccessCardItem from './AccessCardItem';
import PopupAccessLink from './PopupAccessLink';

export default function AccessCard(props) {
    const [visibility, setVisibility] = useState(false);
    const [accessInfos, setAccessInfos] = useState(null);

    useEffect(() => {
        if (props.accessInfos)
            setAccessInfos(props.accessInfos);
    }, [props.accessInfos]);

    async function unlinkAccess(access) {
        const accessNumber = accessServices.accessTypes.find(obj => obj[1] === access)[0];
        if (props.accessInfos && props.accessInfos.id) {
            // eslint-disable-next-line no-restricted-globals
            if (confirm(`Deseja retirar o acesso "${access}" do usuário ${props.accessInfos.nome}?`)) {
                const response = await accessServices.takeAccess(props.accessInfos.id, [accessNumber]);
                if (response.status === 200) {
                    if (props.onUpdate) props.onUpdate(response.data);
                } else
                    alert("Erro ao retirar acesso do usuário, tente novamente");
            }
        } else
            alert("Erro ao identificar usuário, tente novamente!");
    }

    return (
        <div className='access-page-card' id='card-access'>
            <div className='access-card-header'>
                <h4><b><FaUsers />Acessos do usuário</b></h4>
                {
                    props.accessInfos && props.accessInfos.id ?
                        <>
                            <button
                                onClick={() => { setVisibility(true) }}
                            >
                                Dar acessos
                            </button>
                            <PopupAccessLink
                                visibility={visibility}
                                setVisibility={setVisibility}
                                userID={accessInfos ? accessInfos.id : null}
                                userAccesses={props.accessInfos.tipos}
                                onLink={props.onUpdate}
                            />
                        </>
                        : []
                }
            </div>
            {
                props.accessInfos.tipos ?
                    props.accessInfos.tipos.length ?
                        <ul className='access-card-list'>
                            {
                                props.accessInfos.tipos.map((item, index) =>
                                    <AccessCardItem
                                        key={item.id}
                                        tipo={item.tipo}
                                        unlink={() => unlinkAccess(item.tipo)}
                                    />
                                )
                            }
                        </ul>
                        : []
                    : <ActivityIndicator />
            }
        </div>
    )
}